import Service from "./Service";

export default class FormService extends Service {
    constructor() {
        super();
    }

    async save($form) {
        return $.ajax({
            url: $form.attr('action'),
            beforeSend: function(xhr) {
                let csrf = $('meta[name="csrf-token"]').attr('content');
                if (csrf) {
                  xhr.setRequestHeader('X-CSRF-Token', csrf);
                }
            },
            type: 'PATCH',
            dataType: 'json',
            data: $form.serialize()
        });
    }
}